<template>
<div id="EmptyContent" class="empty-container">
  <img :src="img" alt="" />
  <p class="ft-grey"> {{ text }}</p>
</div>
</template>

<script>
import DefaultEmptyImg from '@/assets/image/data_empty.png'
export default {
  name: 'EmptyContent',
  props: {
    img: {
      type: String,
      default: DefaultEmptyImg
    },
    text: {
      type: String,
      default: '暂无相关数据'
    }
  },
}
</script>

<style lang="less" scoped>
.empty-container{
  text-align: center;
}
.ft-grey{
  color: @theme-text-secondary;
}
</style>
